import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import LandingPage from './pages/LandingPage';
import AboutPage from './pages/AboutPage';
import ClientDashboard from './pages/ClientDashboard';
import AdminDashboard from './pages/AdminDashboard';
import CoursesPage from './pages/CoursesPage';
import CourseDetail from './pages/CourseDetail';
import ExerciseDetail from './pages/ExerciseDetail';
import PaymentSuccess from './pages/PaymentSuccess';
import MessagesPage from './pages/MessagesPage';
import CommunityPage from './pages/CommunityPage';
import SubscriptionPage from './pages/SubscriptionPage';
import AdminCourseManager from './pages/AdminCourseManager';
import RefundPolicyPage from './pages/RefundPolicyPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import './App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      fetch(`${API}/auth/me`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(res => {
        if (!res.ok) throw new Error('Token expired');
        return res.json();
      })
      .then(data => {
        if (data && data.id) {
          setUser(data);
        } else {
          localStorage.removeItem('token');
        }
        setLoading(false);
      })
      .catch(() => {
        localStorage.removeItem('token');
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5F5F0]">
        <div className="text-[#1A3C34] text-xl">Loading...</div>
      </div>
    );
  }

  return (
    <div className="App">
      <Toaster position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage user={user} setUser={setUser} />} />
          <Route path="/about" element={<AboutPage />} />
          <Route 
            path="/dashboard" 
            element={user ? <ClientDashboard user={user} setUser={setUser} /> : <Navigate to="/" />} 
          />
          <Route 
            path="/admin" 
            element={user?.role === 'admin' ? <AdminDashboard user={user} setUser={setUser} /> : <Navigate to="/" />} 
          />
          <Route 
            path="/admin/courses/:courseId" 
            element={user?.role === 'admin' ? <AdminCourseManager user={user} /> : <Navigate to="/" />} 
          />
          <Route path="/courses" element={<CoursesPage user={user} />} />
          <Route path="/courses/:courseId" element={<CourseDetail user={user} />} />
          <Route path="/exercises/:exerciseId" element={<ExerciseDetail user={user} />} />
          <Route path="/subscription" element={<SubscriptionPage user={user} />} />
          <Route path="/payment-success" element={<PaymentSuccess user={user} setUser={setUser} />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route 
            path="/messages" 
            element={user ? <MessagesPage user={user} /> : <Navigate to="/" />} 
          />
          <Route 
            path="/community" 
            element={user ? <CommunityPage user={user} /> : <Navigate to="/" />} 
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
